import {
  // -- GET (list)
  GET_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS,
  GET_FLOW_TASK_INTERACTION_VARIABLE_FAILURE,
  // -- CREATE
  CREATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS,
  CREATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS,
  UPDATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE,
  // -- DELETE
  DELETE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS,
  DELETE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowTaskInteractionVariables = (state = {}, action) => {
  switch (action.type) {
    // -- GET (list)
    case GET_FLOW_TASK_INTERACTION_VARIABLE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionVariables.GET_FLOW_TASK_INTERACTION_VARIABLE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case GET_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionVariables.GET_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- CREATE
    case CREATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionVariables.CREATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case CREATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionVariables.CREATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- UPDATE
    case UPDATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionVariables.UPDATE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionVariables.UPDATE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS()',
        { state, action }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- DELETE
    case DELETE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionVariables.DELETE_FLOW_TASK_INTERACTION_VARIABLE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case DELETE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionVariables.DELETE_FLOW_TASK_INTERACTION_VARIABLE_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
